// src/components/ProductSection.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  fetchMirrorDisplayProducts,
  fetchFinishedDisplayProducts,
  fetchAllMirrorProducts,
  fetchAllFinishedProducts,
} from '../store/actions/productActions';
import Loading from './Loading';
import styles from '../styles/ProductSection.module.css';

// 映射 type 到主图图片路径
const typeToImageMap = {
  gpt: '/images/gpt-main.jpg',
  vip: '/images/vip-main.jpg',
  grok: '/images/grok-main.jpg',
  claude: '/images/claude-main.jpg',
  mj: '/images/mj-main.jpg',
  default: '/images/default-main.jpg', // 默认图片
};

const ProductCardPlaceholder = () => (
  <div className={styles.productCard}>
    <div className={styles.imagePlaceholder}>
      <div className={styles.placeholderIcon}></div>
    </div>
    <div className={styles.placeholderText}></div>
    <div className={styles.placeholderText}></div>
    <div className={styles.placeholderButton}></div>
  </div>
);

const ProductSection = ({ id, title, products: staticProducts }) => {
  const dispatch = useDispatch();
  const { loading, displayMirrors, displayFinished, allMirrors, allFinished, error } = useSelector(
    (state) => state.products
  );
  const [hasFetched, setHasFetched] = useState(false); // 添加标记

  console.log(`ProductSection rendered for id: ${id}`);

  useEffect(() => {
    console.log(`ProductSection useEffect triggered for id: ${id}`);
    if (hasFetched || loading) return; // 防止重复调用
    if (id === 'mirrors' && !displayMirrors.length) {
      console.log('Dispatching fetchMirrorDisplayProducts');
      dispatch(fetchMirrorDisplayProducts());
      setHasFetched(true);
    } else if (id === 'products' && !displayFinished.length) {
      console.log('Dispatching fetchFinishedDisplayProducts');
      dispatch(fetchFinishedDisplayProducts());
      setHasFetched(true);
    } else if (id === 'all-mirrors' && !allMirrors.length) {
      console.log('Dispatching fetchAllMirrorProducts');
      dispatch(fetchAllMirrorProducts());
      setHasFetched(true);
    } else if (id === 'all-products' && !allFinished.length) {
      console.log('Dispatching fetchAllFinishedProducts');
      dispatch(fetchAllFinishedProducts());
      setHasFetched(true);
    }
  }, [dispatch, id, displayMirrors, displayFinished, allMirrors, allFinished, loading, hasFetched]);

  const displayProducts =
    id === 'mirrors'
      ? displayMirrors
      : id === 'products'
      ? displayFinished
      : id === 'all-mirrors'
      ? allMirrors
      : id === 'all-products'
      ? allFinished
      : staticProducts;

  if (loading && (id === 'mirrors' || id === 'products' || id === 'all-mirrors' || id === 'all-products')) {
    return (
      <section id={id} className={styles.productSection}>
        <div className={styles.container}>
          <h2 className={styles.sectionTitle}>{title}</h2>
          <div className={styles.productGrid}>
            {[...Array(4)].map((_, index) => (
              <ProductCardPlaceholder key={index} />
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (error && (id === 'mirrors' || id === 'products' || id === 'all-mirrors' || id === 'all-products')) {
    return (
      <section id={id} className={styles.productSection}>
        <div className={styles.container}>
          <h2 className={styles.sectionTitle}>{title}</h2>
          <p>加载失败: {error}</p>
        </div>
      </section>
    );
  }

  return (
    <section id={id} className={styles.productSection}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>{title}</h2>
        <div className={styles.productGrid}>
          {displayProducts.map((product) => (
            <div key={product.id} className={styles.productCard}>
              <div className={styles.imagePlaceholder}>
                {/* 根据 type 动态加载主图图片 */}
                <img
                  src={typeToImageMap[product.type] || typeToImageMap.default}
                  alt={`${product.name} 主图`}
                  className={styles.mainImage}
                />
              </div>
              <h3>{product.name}</h3>
              <p>价格: ￥{product.price}</p>
              <Link
                to={`/product/${product.id}?type=${product.type || 'gpt'}`}
                className={styles.btn}
              >
                查看详情
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default React.memo(ProductSection);